import {useState, useEffect} from 'react';
import styles from './ScrollToTop.module.css';

const ScrollTop = () => {
    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        const handleScroll = event => {
          setShowScroll(window.scrollY > 500);
        };
    
        window.addEventListener('scroll', handleScroll);
      }, []);


    return (
        <div className={showScroll ? styles.ScrollTopDiv : `${styles.ScrollTopDiv} ${styles.hide}`} onClick={() => {
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          }}>
            <div className={styles.Scroller}>
                <img src={`${process.env.NEXT_PUBLIC_APP_CDN_URL}icons/scrolltotop-white.svg`} height="30" width="24" alt="^" aria-hidden={true} />
            </div>
        </div>
    )
}
    


export default ScrollTop;
